/**
 * DevExtreme (esm/__internal/scheduler/appointments/data_provider/utils/get_appointment_filter/get_appointment_occurrence_dates.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    dateUtilsTs
} from "../../../../../core/utils/date";
import {
    dateUtils
} from "../../../../../core/utils/m_date";
const toMs = dateUtils.dateToMilliseconds;
const SECOND_MS = toMs("second");
const DAY_MS = toMs("day");
const DAY_WITHOUT_ONE_SECOND_MS = toMs("day") - toMs("second");
export const getShiftedAllDayStartDate = (originalStartDate, viewOffset) => {
    const trimmedDate = dateUtils.trimTime(originalStartDate);
    const startOfDay = dateUtilsTs.addOffsets(trimmedDate, [viewOffset]);
    const endOfDay = dateUtilsTs.addOffsets(trimmedDate, [DAY_WITHOUT_ONE_SECOND_MS, viewOffset]);
    switch (true) {
        case originalStartDate > endOfDay:
            return dateUtilsTs.addOffsets(endOfDay, [SECOND_MS]);
        case originalStartDate < startOfDay:
            return dateUtilsTs.addOffsets(startOfDay, [-DAY_MS]);
        default:
            return startOfDay
    }
};
export const getShiftedAllDayEndDate = (originalEndDate, viewOffset) => {
    const trimmedDate = dateUtils.trimTime(originalEndDate);
    const startOfDay = dateUtilsTs.addOffsets(trimmedDate, [viewOffset]);
    const endOfDay = dateUtilsTs.addOffsets(trimmedDate, [DAY_WITHOUT_ONE_SECOND_MS, viewOffset]);
    switch (true) {
        case originalEndDate > endOfDay:
            return dateUtilsTs.addOffsets(endOfDay, [DAY_MS]);
        case originalEndDate < startOfDay:
            return dateUtilsTs.addOffsets(startOfDay, [-SECOND_MS]);
        default:
            return endOfDay
    }
};
export const getAppointmentOccurrenceDates = (_ref, viewOffset) => {
    let {
        startDate: originalStartDate,
        endDate: originalEndDate,
        allDay: allDay
    } = _ref;
    switch (true) {
        case !allDay:
            return {
                startDate: originalStartDate, endDate: originalEndDate
            };
        case 0 === viewOffset:
            return {
                startDate: dateUtils.trimTime(originalStartDate), endDate: dateUtilsTs.addOffsets(dateUtils.trimTime(originalEndDate), [DAY_WITHOUT_ONE_SECOND_MS])
            };
        default:
            return {
                startDate: getShiftedAllDayStartDate(originalStartDate, viewOffset), endDate: getShiftedAllDayEndDate(originalEndDate, viewOffset)
            }
    }
};
